import html2canvas from "html2canvas";
import jsPDF from "jspdf";

async function capture(node) {
  return html2canvas(node, {
    backgroundColor: "#ffffff",
    scale: 2,
    useCORS: true,
    windowWidth: node.scrollWidth,
    windowHeight: node.scrollHeight,
    onclone: (doc, clone) => {
      // Unclip scroll containers so full content is rendered
      const all = clone.querySelectorAll("*");
      all.forEach((el) => {
        const style = window.getComputedStyle(el);
        if (style.overflow === "auto" || style.overflow === "scroll" || style.overflowY === "auto" || style.overflowY === "scroll" || style.overflowX === "auto" || style.overflowX === "scroll") {
          el.style.overflow = "visible";
          el.style.maxHeight = "none";
          el.style.maxWidth = "none";
          el.style.height = "auto";
        }
      });
    },
  });
}

export async function exportAsPNG(node, name = "gantt") {
  const canvas = await capture(node);
  const link = document.createElement("a");
  link.download = `${sanitize(name)}.png`;
  link.href = canvas.toDataURL("image/png");
  link.click();
}

export async function exportAsPDF(node, name = "gantt") {
  const canvas = await capture(node);
  const imgData = canvas.toDataURL("image/png");
  const orientation = canvas.width >= canvas.height ? "landscape" : "portrait";
  const pdf = new jsPDF({ orientation, unit: "pt", format: [canvas.width, canvas.height] });
  pdf.addImage(imgData, "PNG", 0, 0, canvas.width, canvas.height);
  pdf.save(`${sanitize(name)}.pdf`);
}

function sanitize(s) {
  return (s || "export").replace(/[^a-z0-9_\-]+/gi, "_").slice(0, 80);
}
